/***
*
*   CONTACT FORM
*   Will send an email notification to you
*
**********/

import React from 'react';
import { ContactForm } from 'components/lib';

export function Contact(props){

  return(
      <ContactForm />
  )
}
